<template>
  <!-- One rich-text field of the site content document, edited on its own page.
       Used by the Cookie Policy, Privacy Policy, Terms & Conditions and Careers screens. -->
  <content-layout>
    <template #header>{{ title }}</template>
    <template #description>
      <slot name="description"></slot>
    </template>
    <template #header-right>
      <el-button type="primary" :loading="saving" @click="save">Save</el-button>
    </template>

    <div v-loading="loading" class="rich-text">
      <ckeditor v-if="!loading" :editor="editor" v-model="text" :config="editorConfig"></ckeditor>
    </div>
  </content-layout>
</template>

<script>
  import siteContentAPI from "../mixins/api/siteContentAPI";
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

  export default {
    name: "rich-text-page",
    mixins: [siteContentAPI],
    props: {
      // The siteContent field this page edits, e.g. 'cookiePolicy'.
      field: {type: String, required: true},
      title: {type: String, required: true},
    },
    data() {
      return {
        text: '',
        editor: ClassicEditor,
        editorConfig: {},
        siteContent: {},
        loading: true,
        saving: false,
      }
    },

    methods: {
      async save() {
        this.saving = true;
        try {
          this.siteContent[this.field] = this.text;
          await this.patchSiteContent(this.siteContent);
          this.$notify({message: `${this.title} saved`, type: 'success'});
        } catch (err) {
          this.$notify.error({message: err});
        }
        this.saving = false;
      }
    },

    async beforeMount() {
      this.siteContent = await this.getSiteContent();
      this.text = this.siteContent[this.field] || '';
      this.loading = false;
    }
  }
</script>

<style scoped>
  .rich-text {
    min-height: 200px;
    max-width: 960px;
  }

  .rich-text >>> .ck-editor__editable {
    min-height: 420px;
  }
</style>



// WEBPACK FOOTER //
// src/components/rich-text-page.vue